import { createSelector } from 'reselect'

const getAdminOnboardingData = state => state.adminOnboarding

const stepAdminOnboarding = createSelector(
	[getAdminOnboardingData],
	adminOnboarding => ({
		stepIsValid: adminOnboarding.stepIsValid,
	})
)

export default stepAdminOnboarding
